import React from 'react';

/** Política de privacidad pública (para App Store). Ruta /privacidad. */
export const Privacidad: React.FC = () => {
  return (
    <div style={{ maxWidth: 760, margin: '40px auto', padding: '0 20px', color: '#0A0A0A', lineHeight: 1.6, fontFamily: '-apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif' }}>
      <h1 style={{ fontSize: '1.8rem' }}>Política de Privacidad de DashFlow</h1>
      <p style={{ color: '#51606E', fontSize: '.9rem' }}>Última actualización: 3 de junio de 2026</p>

      <p>Esta política describe cómo la app <strong>DashFlow</strong> ("la app") trata tu información. DashFlow es una plataforma de gestión de inventario multicanal para PyMEs.</p>

      <h2 style={{ fontSize: '1.2rem', marginTop: '2rem' }}>1. Información que recopilamos</h2>
      <ul>
        <li><strong>Datos de inicio de sesión:</strong> tu correo electrónico y contraseña.</li>
        <li><strong>Datos de tu negocio:</strong> la información de productos, inventario, ventas, clientes y reportes que vos y tu equipo cargan y administran en su cuenta de DashFlow.</li>
      </ul>
      <p>La app <strong>no</strong> incluye herramientas de seguimiento publicitario ni SDKs de analítica de terceros.</p>

      <h2 style={{ fontSize: '1.2rem', marginTop: '2rem' }}>2. Cómo usamos la información</h2>
      <p>Usamos tu información únicamente para autenticarte y para mostrarte el estado de tu inventario, tus reportes y los datos de tu negocio. No vendemos tus datos ni los usamos con fines publicitarios.</p>

      <h2 style={{ fontSize: '1.2rem', marginTop: '2rem' }}>3. Datos de tu negocio y multi-tenant</h2>
      <p>Cada negocio (tenant) tiene sus datos aislados. Los usuarios que vos autorizás en tu cuenta pueden ver y administrar la información de tu negocio para operarlo.</p>

      <h2 style={{ fontSize: '1.2rem', marginTop: '2rem' }}>4. Integraciones</h2>
      <p>Si conectás canales externos (por ejemplo, MercadoLibre o Tienda Nube), intercambiamos con ellos únicamente los datos necesarios para sincronizar tu stock y tus ventas, según tu autorización.</p>

      <h2 style={{ fontSize: '1.2rem', marginTop: '2rem' }}>5. Almacenamiento en el dispositivo</h2>
      <p>Para mantener tu sesión iniciada guardamos un token de sesión en tu dispositivo. Podés cerrar sesión en cualquier momento desde la app.</p>

      <h2 style={{ fontSize: '1.2rem', marginTop: '2rem' }}>6. Con quién compartimos los datos</h2>
      <p>Tus datos se procesan a través de los servidores de DashFlow para prestar el servicio. No los compartimos con terceros ajenos a la prestación del servicio, salvo obligación legal.</p>

      <h2 style={{ fontSize: '1.2rem', marginTop: '2rem' }}>7. Tus derechos</h2>
      <p>Podés solicitar acceder, corregir o eliminar tus datos escribiéndonos a <a href="mailto:eric.frick@efcloud.tech" style={{ color: '#384DF4' }}>eric.frick@efcloud.tech</a>.</p>

      <h2 style={{ fontSize: '1.2rem', marginTop: '2rem' }}>8. Cambios</h2>
      <p>Podemos actualizar esta política. Publicaremos los cambios en esta misma página con su nueva fecha.</p>

      <h2 style={{ fontSize: '1.2rem', marginTop: '2rem' }}>9. Contacto</h2>
      <p>DashFlow — <a href="mailto:eric.frick@efcloud.tech" style={{ color: '#384DF4' }}>eric.frick@efcloud.tech</a></p>
    </div>
  );
};

export default Privacidad;
